import { createSelector } from 'reselect';

export const selectRouteConfig = (state) => state.services.routeConfig;

export const selectHeadlineBackButtonConfig = createSelector(
  selectRouteConfig,
  (routeConfig) => routeConfig.headlineBackButton,
);

export const routeConfigSelectors = {
  selectRouteConfig,
  selectHeadlineBackButtonConfig,
};
